import { render, staticRenderFns } from "./NewGame.vue?vue&type=template&id=6806fe33&"
import script from "./NewGame.vue?vue&type=script&lang=ts&"
export * from "./NewGame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports